<div [attr.data-test]="containerTestSelector()">
  <mwe-card-selectable (changed)="onProductSelect($event)" [isSelected]="isOrdered()" [disabled]="isDisabled()" [readonly]="isReadonly()">
    <mwe-product-icon [category]="product().category" size="md" [textNodeType]="headlineService.getHeadline(0)" />

    @if (showTariffClasses()) {
      <div class="mt-1" [innerHTML]="fakeProductForTariffClassTranslations() | translateTariffClass | async"></div>
    }

    @if (showNumber() && number()) {
      <div class="mt-1" [innerHTML]="numberText() | translate: number()"></div>
    }

    <div class="mt-1 text--legal">
      {{ product().category | correlatedCompanyReference }}
    </div>
  </mwe-card-selectable>

  @if (showTVInfoText()) {
    <div class="row gx-1 font-size-12 text-neutral-600 mt-1">
      <div class="col-auto"><i aria-hidden="true" class="fa fa-info-circle"></i></div>
      <div class="col">
        <span>{{ 'newClient.information' | translate }}</span>
      </div>
    </div>
  }

  @if (showInformationText()) {
    <div class="row gx-1 font-size-12 text-neutral-600 mt-1">
      <div class="col-auto"><i aria-hidden="true" class="fa fa-info-circle"></i></div>
      <div class="col">
        <span>{{ 'relocation.information' | translate: { category: informationTextProductCategory() } }}</span>
      </div>
    </div>
  }
</div>
